import { createAction } from "redux-actions";
import { FeedConstants } from "../constants/feed.constants";

export const feedRequest = createAction(FeedConstants.FEED_REQUEST);
export const feedSuccess = createAction(FeedConstants.FEED_SUCCESS);
export const feedFailure = createAction(FeedConstants.FEED_FAILURE);
export const resetFeed = createAction(FeedConstants.RESET_FEED);



// WEBPACK FOOTER //
// ./src/actions/feed.actions.js